(function(){
  if (window.__slLoaded) return; window.__slLoaded = true;
  document.documentElement.classList.add('sl-js');
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var io = ('IntersectionObserver' in window) ? new IntersectionObserver(function(entries){
    entries.forEach(function(e){ if (e.isIntersecting){ e.target.classList.add('is-in'); if (e.target._slOnIn) e.target._slOnIn(); io.unobserve(e.target); } });
  }, {threshold: 0.15}) : null;
  function watch(el, fn){ if (fn) el._slOnIn = fn; if (io) io.observe(el); else { el.classList.add('is-in'); if (fn) fn(); } }

  function initReveal(root){ root.querySelectorAll('.sl-reveal, .sl-hero__media').forEach(function(el){ if (el.dataset.slInit) return; el.dataset.slInit = '1'; watch(el); }); }

  function initType(root){
    root.querySelectorAll('.sl-type').forEach(function(el){
      if (el.dataset.slInit) return; el.dataset.slInit = '1';
      var words; try { words = JSON.parse(el.getAttribute('data-words') || '[]'); } catch(e){ words = []; }
      if (words.length < 2 || reduce) return;
      var w = 0, i = words[0].length, del = true;
      function tick(){
        if (!document.body.contains(el)) return;
        var word = words[w];
        if (del){ i--; el.textContent = word.slice(0, i); if (i <= 0){ del = false; w = (w + 1) % words.length; } setTimeout(tick, 45); }
        else { i++; el.textContent = words[w].slice(0, i); if (i >= words[w].length){ del = true; setTimeout(tick, 2200); } else setTimeout(tick, 85); }
      }
      setTimeout(tick, 2600);
    });
  }

  function initRing(root){
    root.querySelectorAll('.sl-min__ring').forEach(function(ring){
      if (ring.dataset.slRing) return; ring.dataset.slRing = '1';
      var fg = ring.querySelector('.fg'); var pct = parseFloat(ring.getAttribute('data-pct') || '0');
      var num = ring.querySelector('.sl-min__num'); var target = parseInt(num ? num.getAttribute('data-n') : '0', 10) || 0;
      watch(ring, function(){
        fg.style.strokeDashoffset = String(691 - 691 * Math.min(pct, 100) / 100);
        if (!num || reduce) return; var s = null;
        function step(t){ if (!s) s = t; var p = Math.min((t - s) / 1600, 1); num.textContent = Math.round(target * p); if (p < 1) requestAnimationFrame(step); }
        requestAnimationFrame(step);
      });
    });
  }

  function initProg(root){
    root.querySelectorAll('.sl-prog').forEach(function(box){
      if (box.dataset.slInit) return; box.dataset.slInit = '1';
      var data; try { data = JSON.parse(box.querySelector('.sl-prog__data').textContent); } catch(e){ return; }
      var range = box.querySelector('.sl-prog__range'), label = box.querySelector('.sl-prog__label'), desc = box.querySelector('.sl-prog__desc');
      if (!range || !data.length) return;
      function show(v){ var d = data[v]; if (!d) return; label.textContent = d.l; desc.textContent = d.t; range.value = v; range.style.setProperty('--p', (data.length > 1 ? v / (data.length - 1) * 100 : 100) + '%'); }
      range.addEventListener('input', function(){ show(parseInt(range.value, 10)); });
      box.querySelectorAll('.sl-prog__ticks button').forEach(function(b){ b.addEventListener('click', function(){ show(parseInt(b.getAttribute('data-i'), 10)); }); });
      show(0);
    });
  }

  function initRut(root){
    root.querySelectorAll('.sl-rut').forEach(function(box){
      if (box.dataset.slInit) return; box.dataset.slInit = '1';
      var tip = box.querySelector('.sl-rut__tip'); var days = box.querySelectorAll('.sl-rut__day');
      function open(d){ days.forEach(function(x){ x.classList.remove('is-open'); x.setAttribute('aria-pressed', 'false'); }); d.classList.add('is-open'); d.setAttribute('aria-pressed', 'true'); tip.innerHTML = ''; var b = document.createElement('b'); b.textContent = d.getAttribute('data-title'); var p = document.createElement('span'); p.textContent = d.getAttribute('data-tip'); tip.appendChild(b); tip.appendChild(p); }
      days.forEach(function(d){ d.addEventListener('click', function(){ open(d); }); d.addEventListener('mouseenter', function(){ if (window.matchMedia('(hover: hover)').matches) open(d); }); });
      if (days[0]) open(days[0]);
    });
  }

  function initMagnet(root){
    if (!window.matchMedia('(hover: hover)').matches || reduce) return;
    root.querySelectorAll('.sl-magnet').forEach(function(btn){
      if (btn.dataset.slInit) return; btn.dataset.slInit = '1';
      btn.addEventListener('mousemove', function(e){ var r = btn.getBoundingClientRect(); var x = (e.clientX - r.left - r.width / 2) / r.width, y = (e.clientY - r.top - r.height / 2) / r.height; btn.style.transform = 'translate(' + (x * 6) + 'px,' + (y * 6) + 'px)'; });
      btn.addEventListener('mouseleave', function(){ btn.style.transform = ''; });
    });
  }

  function initProduct(root){
    root.querySelectorAll('.sl-pp').forEach(function(pp){
      if (pp.dataset.slInit) return; pp.dataset.slInit = '1';
      var main = pp.querySelector('.sl-pp__main img');
      function setMain(src, id){ if (!main || !src) return; main.src = src; main.removeAttribute('srcset'); pp.querySelectorAll('.sl-pp__thumb').forEach(function(t){ t.classList.toggle('is-active', t.getAttribute('data-id') === String(id)); }); }
      pp.querySelectorAll('.sl-pp__thumb').forEach(function(t){ t.addEventListener('click', function(){ setMain(t.getAttribute('data-src'), t.getAttribute('data-id')); }); });
      var q = pp.querySelector('.sl-pp__qty input');
      pp.querySelectorAll('.sl-pp__qty button').forEach(function(b){ b.addEventListener('click', function(){ var v = parseInt(q.value, 10) || 1; v += parseInt(b.getAttribute('data-d'), 10); q.value = Math.max(1, v); }); });
      var dataEl = pp.querySelector('.sl-pp__variants'); if (!dataEl) return;
      var variants; try { variants = JSON.parse(dataEl.textContent); } catch(e){ return; }
      var idInput = pp.querySelector('input[name="id"]'), price = pp.querySelector('.sl-pp__now'), cmp = pp.querySelector('.sl-pp__was'), btn = pp.querySelector('.sl-pp__add'), btnLabel = btn ? btn.getAttribute('data-label') : '', soldLabel = btn ? btn.getAttribute('data-sold') : '';
      function update(){
        var sel = []; pp.querySelectorAll('.sl-pp__opt').forEach(function(f){ var c = f.querySelector('input:checked'); sel.push(c ? c.value : null); });
        var v = variants.filter(function(x){ return x.o.every(function(val, i){ return val === sel[i]; }); })[0];
        if (!v) { if (btn){ btn.disabled = true; btn.textContent = soldLabel; } pp.classList.add('is-soldout'); return; }
        idInput.value = v.id; if (price) price.textContent = v.p; if (cmp){ cmp.textContent = v.c || ''; cmp.style.display = v.c ? '' : 'none'; }
        if (btn){ btn.disabled = !v.a; btn.textContent = v.a ? btnLabel : soldLabel; }
        pp.classList.toggle('is-soldout', !v.a);
        if (v.img) setMain(v.img, v.mid);
      }
      pp.querySelectorAll('.sl-pp__opt input').forEach(function(i){ i.addEventListener('change', update); });
    });
  }

  function initAll(e){ var root = (e && e.target && e.target.querySelectorAll) ? e.target : document; initReveal(root); initType(root); initRing(root); initProg(root); initRut(root); initMagnet(root); initProduct(root); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll); else initAll();
  document.addEventListener('shopify:section:load', initAll);
})();
